<template>
  <div class="options-list mt-3 px-3 py-1">
<!--    <button class="btn btn-sm btn-outline-secondary mb-2" @click="clearAllLayers">Clear All</button>-->
    <div class="form-group">
      <input type="text" class="form-control my-2" placeholder="Filter by type..." v-model="searchQuery"/>
    </div>
    <!-- New full-width Clear-All button  -->
    <button
      class="btn-clear-all d-flex align-items-center justify-content-center mb-3 mt-3"
      @click="clearAllLayers"
    >
      <!-- trash / reset icon -->
      <i class="material-icons md-18">clear_all</i>
      <span class="ml-2">Clear&nbsp;All</span>
    </button>
    <div
      class="option-item"
      v-for="poi in filteredPoiList"
      :key="poi.layerName"
    >
      <input
        type="checkbox"
        :id="`toggle-${poi.layerName}`"
        :checked="isPoiActive(poi)"
        @change="togglePoi(poi)"
        style="display: none"
      />

      <label
        class="custom-checkbox d-flex justify-content-between"
        role="switch"
        :aria-checked="isPoiActive(poi)"
        @click="togglePoi(poi)"
      >
        <div class="d-flex justify-content-between align-items-center">
          <img
            :src="poi.getPublicImageIcon()"
            :alt="poi.prettyName()"
            class="poi-icon"
            :class="{ selected: isPoiActive(poi) }"
            width="25"
          />
          <span class="ml-2 label-text">{{ poi.prettyName() }}</span>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="21" viewBox="0 0 42 21" fill="none">
          <rect
            width="42"
            height="21"
            rx="10.5"
            :fill="isPoiActive(poi) ? poi.getColor() : '#CCC'"
          />
          <circle
            class="switch-circle"
            :class="{ 'switch-circle-active': isPoiActive(poi) }"
            cx="11.5"
            cy="10.5"
            r="8.5"
            fill="white"
          />
        </svg>
      </label>
      <hr>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'MapDataPOIsTab',
  data() {
    return {
      searchQuery: ''
    };
  },
  computed: {
    ...mapState('mapDataPOIs', ['poiList', 'activatedPois']),
    ...mapGetters('mapDataPOIs', ['isPoiActive']),

    filteredPoiList() {
      if (!this.searchQuery) {
        return this.poiList;
      }
      return this.poiList.filter(poi => {
        const searchTerm = this.searchQuery.toLowerCase();
        const poiName = poi.prettyName()
          .toLowerCase();
        return poiName.includes(searchTerm);
      });
    }
  },
  methods: {
    ...mapActions('mapDataPOIs', ['togglePoi', 'initActivePois', 'viewCreated', 'beforeViewDestroyed', 'clearAllPoi']),
    clearAllLayers() {
      this.clearAllPoi();
    },
  },
  created() {
    this.viewCreated();
  },
  beforeDestroy() {
    this.beforeViewDestroyed();
  },
};
</script>

<style scoped>
.options-list {
  padding: 0;
  margin: 0;
}

.option-item {
  padding: 10px 0;
}

.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.label-text {
  font-size: 1em;
  font-weight: 500;
}

.switch-circle {
  transition: transform 0.3s ease;
}

.switch-circle-active {
  transform: translateX(19px);
}

/* Optional search input styling */
.form-control {
  padding: 8px 12px;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out;
}

/* add to <style scoped> ― or merge with your existing rules */
.btn-clear-all {
  width: 100%;
  background-color: #ff5c5c;          /* soft alert red */
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  padding: 10px 12px;
  transition: background-color 0.2s ease-in-out, transform 0.15s ease-in-out;
}

.btn-clear-all:hover {
  background-color: #ff7070;          /* slightly lighter on hover */
}

.btn-clear-all:active {
  transform: scale(0.97);
}

.btn-clear-all .material-icons {
  font-size: 18px;   /* same visual size as before */
  line-height: 1;
  flex-shrink: 0;
}

</style>
